import cx from "classix";
import styles from "./BadgeDato.module.scss";

// Fuente única del badge de origen de dato en /categorias/* (10.1) — reemplaza los
// <span className={styles.badgeIpsos}> locales de cada página. El número visible (children)
// no cambia; lo único nuevo es el color (azul = Ipsos, gris = supuesto comercial) y el
// tooltip (title), que dice de dónde sale el valor. `className` permite que la página
// combine su propio override visual (ej. badgeOportunidad en rojo, badgeIpsosGrande) sin
// perder el color por tipo.
const tituloIpsos = (dato) => {
  const partes = [`IPSOS · lám. ${dato.lamina}`];
  if (dato.pregunta) partes.push(dato.pregunta);
  if (dato.base) partes.push(`base ${dato.base}`);
  if (dato.nota) partes.push(dato.nota);
  return partes.join(" — ");
};

const tituloSupuesto = (dato) => {
  const partes = ["Supuesto comercial"];
  if (dato.nota) partes.push(dato.nota);
  partes.push(`definido por ${dato.definidoPor || "Ignacio"}${dato.fecha ? ` (${dato.fecha})` : ""}`);
  return partes.join(" — ");
};

export const BadgeDato = ({ dato, className, children }) => {
  const esSupuesto = dato?.tipo === "supuesto";
  const title = dato ? (esSupuesto ? tituloSupuesto(dato) : tituloIpsos(dato)) : undefined;

  return (
    <span className={cx(styles.badge, esSupuesto && styles.supuesto, className)} title={title}>
      {children}
    </span>
  );
};

export default BadgeDato;
